import { urls } from '@getstream/ui-library/build';

export const conclusion = {
  conclusion:
    "This tutorial showed you the basics of what's possible with Stream. Setting up scalable feeds on your own can take months. Stream makes it easy and gives you the tools to improve user engagement within your app. Time to add a feed to your app! Client libraries are available for Node, PHP, Ruby, Python, Java, Golang, and .NET. ",
  components: [
    { icon: 'IconReact', label: 'React', to: urls.feeds.tutorials.react },
    {
      icon: 'IconReact',
      label: 'React Native',
      to: urls.feeds.tutorials.react_native,
    },
    { icon: 'IconIos', label: 'IOS/Swift', to: urls.feeds.tutorials.ios },
  ],
  docs: {
    label: 'feeds docs',
    to: urls.feeds.docs,
  },
};
